<script lang="ts">
  import { fly } from "svelte/transition";
  import { backOut } from "svelte/easing";
  import CheckCircle from "../icons/CheckCircle.svelte";

  interface Props {
    message: string;
  }

  const { message }: Props = $props();
</script>

<div
  class="absolute -top-14 right-0 z-50 w-fit transform"
  transition:fly={{ x: 50, duration: 500, easing: backOut }}
>
  <div class="relative">
    <div
      class="flex min-w-max items-center gap-2.5 rounded-xl bg-mono-000 px-3 py-2.5 text-sm whitespace-nowrap shadow-border-popover"
    >
      <div class="flex items-center justify-center text-pri-700">
        <CheckCircle />
      </div>
      <span class="text-foreground-primary">{message}</span>
    </div>
  </div>
</div>
